import Promise from 'promise';

export default function (file, maxSizeH, maxSizeW) {
	var promise = new Promise(function (resolve, reject) {
		var reader = new FileReader();
		reader.onload = function (e) {
			var img = document.createElement('img');
			img.onload = function () {
				var canvas = document.createElement('canvas');
				var ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0);

				var MAX_WIDTH = maxSizeW;
				var MAX_HEIGHT = maxSizeH;
				var width = img.width;
				var height = img.height;

				if (width > height) {
					if (width > MAX_WIDTH) {
						height *= MAX_WIDTH / width;
						width = MAX_WIDTH;
					}
				} else {
					if (height > MAX_HEIGHT) {
						width *= MAX_HEIGHT / height;
						height = MAX_HEIGHT;
					}
				}
				canvas.width = width;
				canvas.height = height;
				var ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0, width, height);
				var dataurl = canvas.toDataURL('image/jpeg', 0.75);

				file.imgSrc = dataurl;

				resolve(file);
			}.bind(this);

			img.src = e.target.result;
		}.bind(this);

		reader.readAsDataURL(file);
	});

	return promise.catch((e) => {
		throw e;
	});
}
